import { StyleSheet, UnistylesRuntime } from "react-native-unistyles";

import CustomPlatform from "$src/core/utils/platform/platform";

const stylesheet = StyleSheet.create(
  ({ colors, spacing }, { insets, isLandscape }) => ({
    container: {
      height: "100%",
      width: "100%",
      backgroundColor: colors.backgroundScrim,
    },
    player: {
      justifyContent: "center",
      backgroundColor: colors.backgroundScrim,
      zIndex: 1,
      width: "100%",
      ...CustomPlatform.select({
        tv: {
          height: "100%",
          maxHeight: "100%",
          marginTop: 0,
        },
        web: {
          height: "100%",
          maxHeight: "100%",
          marginTop: 0,
        },
        default: {},
      }),
      variants: {
        isFullscreen: {
          true: {
            ...StyleSheet.absoluteFill,
            zIndex: 1,
            marginTop: 0,
            height: "100%",
            maxHeight: "100%",
          },
          false: CustomPlatform.select({
            tv: {
              height: "100%",
              maxHeight: "100%",
              marginTop: 0,
            },
            web: {
              height: "100%",
              maxHeight: "100%",
              marginTop: 0,
            },
            // A tablet ignores the page's portrait lock, and `aspectRatio` plus a
            // clamped `maxHeight` makes Yoga re-derive the width, which parks a
            // half-size video in the corner. Landscape fills the surface instead.
            default: isLandscape
              ? {
                  height: "100%",
                  maxHeight: "100%",
                  marginTop: 0,
                }
              : {
                  aspectRatio: 16 / 9,
                  maxHeight: "40%",
                  marginTop: CustomPlatform.select({
                    native: insets.top,
                    default: 0,
                  }),
                },
          }),
        },
      },
    },
    noMedia: {
      textAlign: "center",
    },
    content: {
      flexGrow: 1,
      backgroundColor: colors.backgroundDefault,
      paddingHorizontal: {
        xs: spacing(4),
        lg: spacing(6),
      },
      paddingVertical: spacing(8),
      gap: spacing(4),
      variants: {
        isFullscreen: {
          true: {
            display: "none",
          },
        },
      },
    },
    meta: {
      flexDirection: "row",
      alignItems: "center",
    },
    poster: {
      width: spacing(20),
      height: spacing(32),
      objectFit: "cover",
      borderRadius: spacing(2),
      marginRight: spacing(5),
    },
    metaDetails: {
      flexBasis: 0,
      flexGrow: 1,
      flexShrink: 1,
      justifyContent: "center",
      gap: spacing(1),
    },
    title: {
      marginBottom: spacing(1),
    },
    description: {
      opacity: 0.8,
    },
  }),
);

const initialTheme = UnistylesRuntime.getTheme();

export const IMAGE_DIMENSIONS = {
  poster: [
    {
      width: initialTheme.spacing(20),
      height: initialTheme.spacing(32),
    },
  ],
};

export default stylesheet;
